import { ScrollArea } from "@similarweb/ui-components";

export const ScrollAreaWrap = ({ children, ...rest }: FixmeType) => {
    return (
        <ScrollArea
            style={{ maxHeight: 208, minHeight: 0 }}
            verticalScrollbarStyle={{ borderRadius: 5 }}
            horizontal={false}
            smoothScrolling={true}
            minScrollSize={48}
            {...rest}
        >
            {children}
        </ScrollArea>
    );
};
